import useSWR from 'swr';
import { useEffect, useState } from 'react';

export const fetcher = (url: string) =>
  fetch(url, { credentials: 'same-origin' }).then((res) => {
    return res.json();
  });

const useApi = (api: string) => {
  const { data, error } = useSWR(api, fetcher, { revalidateOnFocus: false });
  const [noFetch, setNoFetch] = useState(false);

  useEffect(() => {
    if (!window.fetch) {
      setNoFetch(true);
    }
  }, []);

  return {
    data,
    notLogin: data && data.result === 109,
    isLoading: !error && !data,
    isError: error,
    noFetch,
  };
};

export default useApi;
